import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { WizardFlowType } from '../../@types/wizardFlowType'

export const initialState = { userFirstInteraction: true, wizardFlowType: WizardFlowType.RLE, nonHappyPath: false }

const flowSlice = createSlice({
  name: 'flow',
  initialState: initialState,
  reducers: {
    updateUserFirstInteraction: (state, action: PayloadAction<boolean>) => {
      state.userFirstInteraction = action.payload
    },
    updateWizardFlowType: (state, action: PayloadAction<WizardFlowType>) => {
      state.wizardFlowType = action.payload
    },
    updateNonHappyPath: (state, action: PayloadAction<boolean>) => {
      state.nonHappyPath = action.payload
    },
  },
})

export const { updateUserFirstInteraction, updateWizardFlowType, updateNonHappyPath } = flowSlice.actions
export default flowSlice.reducer
